
























































































































import { Component, Vue } from 'vue-property-decorator';
import BookingCandidateListItem from '../BookingCandidate/BookingCandidateListItem.vue';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { mapState } from 'vuex';
import BookingCandidateListFilterForm from '../BookingCandidate/List/BookingCandidateListFilterForm.vue';
import BookingCandidateListFilterChip from '../BookingCandidate/List/BookingCandidateListFilterChip.vue';
import QDownloadBtn from '@/components/QDownloadBtn.vue';
import { STATUSES, TYPES } from '@/constants/booking';

@Component({
  components: {
    BookingCandidateListItem,
    BookingCandidateListFilterForm,
    BookingCandidateListFilterChip,
    QDownloadBtn,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('BookingCandidate', {
      bookingCandidates: 'bookingCandidates',
    }),
  },
})
export default class CandidateDashboardIncompletedList extends Vue {
  statuses = STATUSES;

  types = TYPES;

  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;

  loading!: boolean;
  bookingCandidates!: any[];

  canStart(item) {
    return (
      item.status &&
      [
        this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
        this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
      ].includes(item.status)
    );
  }

  canStartOver(item) {
    return (
      item.status ==
        this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key &&
      item.questionnaire_answer &&
      item.questionnaire_answer?.progress > 0
    );
  }

  isIncomplete(item) {
    return (
      !item.questionnaire_answer || item.questionnaire_answer?.progress === 0
    );
  }

  toConsent(bookingCandidateOid) {
    this.$router.push({
      name: 'candidate-booking-candidate-read',
      params: {
        bookingCandidateOid,
      },
    });
  }

  async toStartOver(item) {
    await this.$store.dispatch(
      'QuestionnaireAnswer/startOver',
      item.questionnaire_answer.object_id
    );

    this.toStart(item.object_id);
  }

  async toStart(bookingCandidateOid) {
    this.$store
      .dispatch('BookingCandidate/startQuestionnaire', bookingCandidateOid)
      .then(() => {
        this.$store
          .dispatch('BookingCandidate/fetch', bookingCandidateOid)
          .then(() => {
            this.$router.push({
              name: 'candidate-start-selected-questionnaire',
              params: {
                beOid: bookingCandidateOid,
              },
            });
          });
      });
  }
}
